module.exports = __webpack_public_path__ + "img/23.71afe6e3.png";